const Colors = {
  primary: {
    ultrasoft: "#115AE6",
    soft: "#115AD2",
    medium: "#115ABE",
    hard: "#115AAA",
    dark: "#115A96",
  },
  secondary: {
    ultrasoft: "#FFE16B",
    soft: "#FFD638",
    medium: "#FFCC05",
    hard: "#D1A600",
    dark: "#9E7E00",
  },
  neutral: {
    ultrasoft: "#E6E6E6",
    soft: "#D9D9D9",
    medium: "#BEBEBE",
    hard: "#A6A6A6",
    dark: "#8C8C8C",
  },
  success: {
    ultrasoft: "#A2F6D8",
    soft: "#74F1C4",
    medium: "#47EDB1",
    hard: "#17E89D",
    dark: "#17E889",
  },
  warning: {
    ultrasoft: "#FFE7D7",
    soft: "#FECAA4",
    medium: "#FDAC71",
    hard: "#FC8F40",
    dark: "#FC720E",
  },
  error: {
    ultrasoft: "#FED2D2",
    soft: "#FCA1A1",
    medium: "#FB7171",
    hard: "#FA3E3E",
    dark: "#F90B0B",
  },
};

export default Colors;
